export default __webpack_public_path__ + "static/media/bogota.1e94a960.png";